"use strict";

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _defineProperty = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");

var GridSimpleFilterText = function GridSimpleFilterText(type, filter) {
  _classCallCheck(this, GridSimpleFilterText);

  this.type = type;
  this.filter = filter;
  this.filterType = 'text';
};

exports.GridSimpleFilterText = GridSimpleFilterText;

var GridSimpleFilterNumber = function GridSimpleFilterNumber(type, filter) {
  _classCallCheck(this, GridSimpleFilterNumber);

  this.type = type;
  this.filter = filter;
  this.filterType = 'number';
};

exports.GridSimpleFilterNumber = GridSimpleFilterNumber;

var GridSimpleFilterNumberRange = function GridSimpleFilterNumberRange(filter, filterTo) {
  _classCallCheck(this, GridSimpleFilterNumberRange);

  this.filter = filter;
  this.filterTo = filterTo;
  this.filterType = 'number';
  this.type = 'inRange';
};

exports.GridSimpleFilterNumberRange = GridSimpleFilterNumberRange;

var GridSimpleFilterSet = function GridSimpleFilterSet(values) {
  _classCallCheck(this, GridSimpleFilterSet);

  this.values = values;
  this.filterType = 'set';
};

exports.GridSimpleFilterSet = GridSimpleFilterSet;

var GridSimpleFilterDate = function GridSimpleFilterDate(from, to) {
  _classCallCheck(this, GridSimpleFilterDate);

  this.from = from;
  this.to = to;
  this.filterType = 'date';
};

exports.GridSimpleFilterDate = GridSimpleFilterDate; // Grid-Filter Model for custom filter RangeFilter.tsx

var GridCustomFilterDate = function GridCustomFilterDate(from, to) {
  _classCallCheck(this, GridCustomFilterDate);

  this.from = from;
  this.to = to;
  this.filterType = 'custom';
  this.type = 'date';
};

exports.GridCustomFilterDate = GridCustomFilterDate;

var GridFilterSort =
/*#__PURE__*/
function () {
  function GridFilterSort(colId, sort) {
    _classCallCheck(this, GridFilterSort);

    this.colId = colId;
    this.sort = sort;
  }

  _createClass(GridFilterSort, [{
    key: "toMongoFilter",
    value: function toMongoFilter() {
      return _defineProperty({}, this.colId, this.sort === 'asc' ? 1 : -1);
    }
  }]);

  return GridFilterSort;
}();

exports.GridFilterSort = GridFilterSort;

var GridFilter =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(GridFilter, _DomainObject_1$Domai);

  function GridFilter(filter, sorting) {
    var _this;

    _classCallCheck(this, GridFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GridFilter).call(this));
    _this.filter = filter;
    _this.sorting = sorting;
    return _this;
  }

  return GridFilter;
}(DomainObject_1.DomainObject);

exports.GridFilter = GridFilter;
GridFilter.EMPTY = new GridFilter({}, []);